// A typed observable value in about thirty lines. Enough for a prototype:
// one source of truth, subscribers redraw. No library needed.

export type Store<T> = {
  get: () => T;
  set: (next: T | ((current: T) => T)) => void;
  /** Returns an unsubscribe function. */
  subscribe: (listener: (value: T) => void) => () => void;
};

export const createStore = <T>(initial: T): Store<T> => {
  let value = initial;
  const listeners = new Set<(value: T) => void>();

  return {
    get: () => value,

    set: (next) => {
      const resolved = typeof next === 'function' ? (next as (current: T) => T)(value) : next;
      // Object.is keeps a no-op set from redrawing every subscriber.
      if (Object.is(resolved, value)) return;
      value = resolved;
      for (const listener of listeners) listener(value);
    },

    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
};
